import { render } from "./Subtitle.vue?vue&type=template&id=a418bf70"
const script = {}

import "./Subtitle.vue?vue&type=style&index=0&id=a418bf70&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Subtitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a418bf70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a418bf70', __exports__)) {
    console.log('reload')
    api.reload('a418bf70', __exports__)
  }
  
  module.hot.accept("./Subtitle.vue?vue&type=template&id=a418bf70", () => {
    console.log('re-render')
    api.rerender('a418bf70', render)
  })

}


export default __exports__